import React from 'react';

import { ExternalLink, InternalLink } from '../ui-components';
import { handleFormerInternalURLs, isInternalLink, doesLinkContainLocale } from '../utils/link-handler';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and its
 * children
 *
 * @function
 * @param {object} node rich-text node
 * @param {element} children collection of child rich-text nodes
 */
const RichHyperlink = (pageGeo, node, children) => {
  // conditional to check for former mailbox
  if (node.data.uri.includes('mailto:findoutmore@credera.com')) {
    return (
      <ExternalLink linkstyle="secondary-link" target="_blank" href={'mailto:marketing@credera.com'}>
        marketing@credera.com
      </ExternalLink>
    );
  } else {
    // treat internal credera links without locales as internal links, if locale is specified, treat as external - will change user's locale
    return isInternalLink(node.data.uri) && !doesLinkContainLocale(node.data.uri) ? (
      <InternalLink linkstyle="secondary-link" target="_self" to={handleFormerInternalURLs(pageGeo, node.data.uri)}>
        {children}
      </InternalLink>
    ) : (
      <ExternalLink linkstyle="secondary-link" target="_blank" href={handleFormerInternalURLs(pageGeo, node.data.uri)}>
        {children}
      </ExternalLink>
    );
  }
};

export default RichHyperlink;
